export default function uniqueFunctionVendorNameDirective(
  $q,
  emSharedModelService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const functionId = attributes.functionId || -1;
    const vendorId = attributes.vendorId || -1;
    ngModel.$asyncValidators.emFunctionVendorUniqueName = modelValue => emSharedModelService
      .checkFunctionVendorNameExists(functionId, vendorId, modelValue).then((response) => {
        const nameExists = response.data.result;
        if (!nameExists) {
          return $q.resolve();
        }
        return $q.reject();
      })
      .catch(() => $q.reject());
  }
}

export const name = 'emFunctionVendorUniqueName';

uniqueFunctionVendorNameDirective.$inject = [
  '$q',
  'emSharedModelService',
];
